import React, { useState, useCallback, useEffect } from "react";
import Cropper from "react-easy-crop";
import Slider from "@mui/material/Slider";
import Button from "@mui/material/Button";
import { pencilIcon } from '../../Components';
import getCroppedImg from "./CropImageHelper"; // Helper function to extract image
const ImageCropper = ({ imageUrl, setImageSrc, setCroppedImage, setSelectedImage }) => {
    const cropSizeVal = 250;
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [initialZoom, setInitialZoom] = useState(1);
    const [cropSize] = useState({ width: cropSizeVal, height: cropSizeVal }); // fixed crop size
    const [image, setImage] = useState(null); // image reference
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [mediaSize, setMediaSize] = useState(null);
    const [maxZoom, setMaxZoom] = useState(3)
    const [minZoom, setMinZoom] = useState(1)
    // const maxZoom = 3;  // Maximum zoom level
    const onCropComplete = (croppedArea, croppedAreaPixels) => {
        //console.log(croppedArea, croppedAreaPixels)
        setCroppedAreaPixels(croppedAreaPixels)
    }
    const onSliderChange = (event) => {
        if (event.target.value > minZoom) {
            setZoom(event.target.value);
        }
    };
    // Handle Zoom In (+)
    const handleZoomIn = () => {
        setZoom((prevZoom) => Math.min(prevZoom + 0.01, maxZoom));
    };

    // Handle Zoom Out (-)
    const handleZoomOut = () => {
        setZoom((prevZoom) => Math.max(prevZoom - 0.01, minZoom));
    };
    const onMediaLoaded = (media) => {
        const naturalimageWidth = media.naturalWidth;
        const naturalimageHeight = media.naturalHeight;
        const imageWidth = media.width;
        const imageHeight = media.height;
        const diffInDimension = Math.min(imageWidth, imageHeight);
        const zoomCalculated = cropSizeVal / diffInDimension;
        const maxZoomCalculated = (zoomCalculated + 2);
        setZoom(zoomCalculated);
        setMinZoom(zoomCalculated);
        setMaxZoom(maxZoomCalculated)
    };
    // When user clicks the "Crop" button
    const handleCrop = async () => {
        try {
            const croppedImageUrl = await getCroppedImg(
                imageUrl,
                croppedAreaPixels,
                false
            )
            setCroppedImage(croppedImageUrl);
            setSelectedImage(null);
        } catch (e) {
            console.error(e)
        }
    };
    return (
        <div className="profile-photo-container">
            <div className="cropper-modal">
                <div className="cropper-container">
                    {<Cropper
                        image={imageUrl}
                        onMediaLoaded={onMediaLoaded} // Capture image dimensions
                        crop={crop}
                        zoom={zoom}
                        aspect={cropSize.width / cropSize.height}
                        onCropChange={setCrop}
                        onZoomChange={setZoom}
                        onCropComplete={onCropComplete}
                        cropSize={cropSize}
                        cropShape="round" // Make selection circular
                        minZoom={minZoom}
                        maxZoom={maxZoom}
                    />}

                </div>
                {/* Zoom Controls */}
                <div className="zoom-controls">
                    {<button onClick={handleZoomOut}>-</button>}
                    <input
                        type="range"
                        min={minZoom}
                        max={maxZoom}
                        step={0.01}
                        value={zoom} // Sync slider with zoom state
                        onChange={onSliderChange} // Update zoom value when slider changes
                    />
                    {<button onClick={handleZoomIn}>+</button>}
                </div>
                <div className="action-buttons modal__assetDetail-delete-btns">
                    <button className="button secondary" onClick={() => setSelectedImage(null)}>Cancel</button>
                    <button className="button primary" onClick={handleCrop}>Save</button>
                </div>
            </div>
        </div>
    );
};

export default ImageCropper;
